import { useNavigate } from 'react-router-dom';

export default function ColaboradorHome() {
  const navigate = useNavigate();

  const cards = [
    {
      title: 'Solicitação de EPI',
      description: 'Solicite novos equipamentos de proteção individual.',
      icon: 'ri-tools-line',
      path: '/colaborador/epi',
      color: 'bg-portal-purple',
    },
    {
      title: 'Registro de Incidente',
      description: 'Registre ocorrências e incidentes de segurança.',
      icon: 'ri-alarm-warning-line',
      path: '/colaborador/incidente',
      color: 'bg-orange-500',
    },
    {
      title: 'Canal de Denúncias',
      description: 'Faça denúncias de forma anônima ou identificada.',
      icon: 'ri-shield-user-line',
      path: '/colaborador/denuncia',
      color: 'bg-emerald-600',
    },
    {
      title: 'Meu Histórico',
      description: 'Visualize suas solicitações e registros anteriores.',
      icon: 'ri-history-line',
      path: '/colaborador/historico',
      color: 'bg-portal-gray-600',
    },
  ];

  return (
    <div>
      <h1 className="text-xl font-bold text-portal-gray-900 mb-2">Bem-vindo, Colaborador</h1>
      <p className="text-sm text-portal-gray-500 mb-6">
        Escolha uma das opções abaixo para preencher um formulário.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {cards.map((card) => (
          <button
            key={card.path}
            onClick={() => navigate(card.path)}
            className="bg-white rounded-xl border border-portal-gray-200 p-5 text-left hover:border-portal-purple hover:shadow-sm transition-all group"
          >
            <div className={`w-10 h-10 ${card.color} rounded-lg flex items-center justify-center mb-3`}>
              <i className={`${card.icon} text-white text-lg`}></i>
            </div>
            <h3 className="text-sm font-semibold text-portal-gray-800 mb-1 group-hover:text-portal-purple transition-colors">
              {card.title}
            </h3>
            <p className="text-xs text-portal-gray-500">{card.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
}